import React from 'react'
import { Paragraph, useContainerWidth, Separator } from '@fs/zion-ui'

export default function RootsTechBannerSubHeading({ children, ...props }) {
  const atSize = useContainerWidth()

  return (
    <>
      <Separator size={atSize({ default: 'sm', xxl: 'sm' })} />
      <Paragraph size={atSize({ default: 'xs', md: 'sm' })} balanced {...props}>
        <strong>{children}</strong>
      </Paragraph>
    </>
  )
}
